import React, { useContext } from "react";
import { Header } from "@digitallab/grid-common-frontend-components";
import { getEnv, getEnvLabel } from "../../utils/helpers/text";
import { BackendInfoContext } from "../backend-info-context/context";
import styled from "styled-components";
const CustomWrapper = styled.div`
  > div {
    z-index: 1200;
    position: relative;
  }
`;
const currentEnv = getEnv();
const leftLabel = getEnvLabel(currentEnv);
const HeaderSection = () => {
  const { rightLabel } = useContext(BackendInfoContext);
  return (
    <CustomWrapper>
      <Header environment={currentEnv} leftLabel={leftLabel} rightLabel={rightLabel} />
    </CustomWrapper>
  );
};
export default HeaderSection;
